__turbopack_context__.v({
  "cta": "CoreRecentFeaturedNewsInsights-module-scss-module__nRrKCq__cta",
  "description": "CoreRecentFeaturedNewsInsights-module-scss-module__nRrKCq__description",
  "grid": "CoreRecentFeaturedNewsInsights-module-scss-module__nRrKCq__grid",
});
